import { deCodeTokenData } from "../auth/token.service";
import { firebaseIframeLog, firebaseLog } from "./firebase.service";
import { sendKvaEvent } from "./kva.service";

const defaultMerchantId = "000000";

export function firebaseAndKvaLog(
  platform: string | (string | null)[] | null | undefined,
  eventName: string,
  eventParams?: {
    value?: any;
    [key: string]: any;
  },
  options?: {
    eventValue?: string;
    eventLabel?: string;
  }
) {
  const tokenDecode: any = deCodeTokenData();
  const defaultEventParams = {
    platform,
  };
  firebaseLog(eventName, Object.assign(defaultEventParams, eventParams));

  if(typeof tokenDecode.kvrid === 'undefined' && typeof tokenDecode.merchant_ref_id === 'undefined') {
    return
  }

  sendKvaEvent(
    String(platform || "fnb"),
    tokenDecode.kvrid || tokenDecode.merchant_ref_id || defaultMerchantId,
    eventName,
    options?.eventLabel,
    options?.eventValue,
    eventParams
  );
}

export function iframeTracking(
  platform: string | (string | null)[] | null | undefined,
  eventName: string,
  eventParams?: {
    value?: any;
    [key: string]: any;
  },
  options?: {
    eventValue?: string;
    eventLabel?: string;
  }
) {
  const tokenDecode: any = deCodeTokenData();

  firebaseIframeLog(eventName, eventParams);
  sendKvaEvent(
    String(platform || "fnb"),
    tokenDecode.kvrid || defaultMerchantId,
    eventName,
    options?.eventLabel,
    options?.eventValue,
    eventParams
  );
}

export function firebaseAndKvaIframeLog(
  platform: string | (string | null)[] | null | undefined,
  eventName: string,
  eventParams?: {
    value?: any;
    [key: string]: any;
  },
  options?: {
    eventValue?: string;
    eventLabel?: string;
  }
) {
  const tokenDecode: any = deCodeTokenData();

  firebaseIframeLog(eventName, eventParams);
  sendKvaEvent(
    String(platform || "fnb"),
    tokenDecode.kvrid || defaultMerchantId,
    eventName,
    options?.eventLabel,
    options?.eventValue,
    eventParams
  );
}
